<ng-toggle
  [value]="value"
  [color]="{unchecked: '#D8D8D8', checked: '#37A702'}"
  (valueChange)="toggle.emit()"
></ng-toggle>

<p class="email-notif-text">
  {{ label }}
  @if (description) {
<span class="email-notif-desc">{{ description }}</span>
}
</p>
